/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import "./Tile.scss";

export default function Tile({ value, isSelected = false, onTileSelected, ...restProps }: any) {
  function handleClick(clickValue: any) {
    onTileSelected(clickValue);
  }

  return (
    <div {...restProps} className={cn("gang-sheet-builder-pdp-tile", restProps.className)}>
      <div
        className={cn("gang-sheet-builder-pdp-tile__button", {
          "gang-sheet-builder-pdp-tile__button--selected": isSelected
        })}
        onClick={() => {
          handleClick(value.value);
        }}
        data-testid="tile-div"
      >
        {value.label}
      </div>
    </div>
  );
}
